<template>
  <div class="add-machine pad">

    <div class="flex">
      <h2 class="title is-4 flex-1">New Machine</h2>
      <button class="button is-info is-small" @click="back">back</button>
    </div>

    <machine-form @submitted="back" />

  </div>
</template>

<script>
import MachineForm from '@/components/MachineForm'
export default {
  name: 'AddMachine',
  components: {
    MachineForm
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>

</style>
